export default __webpack_public_path__ + "static/media/poison.ec11b086.png";